/* istanbul ignore file */
import { useState, useEffect } from 'react'
import { helpers } from '@adc/core-utils'

const canUseDom = () => helpers.environments.canUseDom()

interface Dimensions {
  height: number
  width: number
}

const DEFAULT_DIMENSIONS: Dimensions = {
  height: 0,
  width: 0,
}

function getWindowDimensions(): Dimensions {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

// hook from stackoverflow: https://stackoverflow.com/questions/36862334/get-viewport-window-height-in-reactjs
export default function useWindowDimensions(): Dimensions {
  const dimensions = canUseDom() ? getWindowDimensions() : DEFAULT_DIMENSIONS
  const [windowDimensions, setWindowDimensions] =
    useState<Dimensions>(dimensions)

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}
